var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradiantLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 8,
    viewBox: "0 0 400 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 8,
    fill: "url(#paint0_linear_520_11649)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_520_11649",
    x1: 0,
    y1: 3.44828,
    x2: 400,
    y2: 3.44949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5265FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764CB6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradiantLine);
export default __webpack_public_path__ + "static/media/gradiantLine.541f2e78b3d2dced020429186247f1bb.svg";
export { ForwardRef as ReactComponent };